<div id="business-equipment-tuple-root" class="form-array" *transloco="let t">
  <app-input
    [id]="'business-equipment-serial-' + index"
    [control]="serial"
    [label]="label"
    required
    [readonly]="id?.value"
  >
  </app-input>

  <span class="new-printer-n mb">
    <span *ngIf="planModel?.value">
      {{ planModel?.value }}
    </span>
    <span *ngIf="!planModel?.value">
      {{ t('new-printer', { n: index + 1 }) }}
    </span>
  </span>

  <span class="normal-column mb">
    <span>Series</span>
    <span *ngIf="familyName?.value">{{ familyName?.value }}</span>
    <span *ngIf="!familyName?.value">-</span>
  </span>

  <span class="normal-column mb">
    <span>{{ t('serial-registration-date') }}</span>
    <span *ngIf="serialRegisterDate?.value">
      {{ serialRegisterDate?.value | date: 'MM.dd.yyyy' }}
    </span>
    <span *ngIf="!serialRegisterDate?.value">
      {{ businessRegisterDate | date: 'MM.dd.yyyy' }}
    </span>
  </span>

  <div
    class="action-button delete mb"
  >
    <span>Note</span>
    <app-icon-click id="notes-info-popup" (click)="toggleNote()"
      >comment</app-icon-click
    >
    <div class="popup-preamble">
      <app-notes-info-popup
        (closeClick)="closeNotes()"
        (saveClick)="saveNote($event)"
        [ngClass]="{ visible: displayNote }"
        [note]="note?.value"
        [canSave]="canSave && !!canAddNotes"
      ></app-notes-info-popup>
    </div>
  </div>

  <div
    class="action-button delete mb"
    *ngIf="canShowDelete && canRemoveTuple && planModel?.value"
  >
    <span>Delete</span>
    <app-icon-click (click)="removeTuple.emit(formGroup)">{{
        'delete'
      }}</app-icon-click>
  </div>
</div>
